import { createFileRoute } from '@tanstack/react-router';
import { KeyRound } from 'lucide-react';
import { ApiKeysManager } from '@/components/api-keys-manager';
import { PageHeader } from '@/components/page-header';

export const Route = createFileRoute('/_app/admin/api-keys')({ component: AdminApiKeysPage });

function AdminApiKeysPage() {
  return (
    <div className="mx-auto w-full max-w-4xl">
      <PageHeader
        title="API keys"
        icon={KeyRound}
        description="Keys for scripts and integrations that manage the panel."
      />
      <ApiKeysManager kind="application" />
    </div>
  );
}
